module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "msg-list-page"
  }, [_c('header-return', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg-detail-board"
  }, [_c('div', {
    staticClass: "msg-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.detailObj.title) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.detailObj.push_time, 'YYYY-MM-DD')))])])]), _vm._v(" "), _c('div', {
    staticClass: "msg-content"
  }, [_c('detail-map', {
    attrs: {
      "configArr": _vm.configObj.cols,
      "detailObj": _vm.detailObj
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73bb36d3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/msg_detail.vue
// module id = 177
// module chunks = 1